import SvgColor from '../../components/svg-color';

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const borrowerNavConfig = (loanId) => [
  {
    title: 'Tasks',
    path: `/borrower/loan/${loanId}/tasks`,
    icon: icon('ic_document'),
  },
  {
    title: 'Loan Status',
    path: `/borrower/loan/${loanId}/status`,
    icon: icon('ic_analytics'),
  },
  {
    title: 'Mortgage Calculator',
    path: `/borrower/loan/${loanId}/calculator`,
    icon: icon('ic_policy'),
  },
];

export default borrowerNavConfig;
